var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-alert',{staticClass:"animated fadeIn text-center",attrs:{"dark":"","elevation":"20","color":"#142638","border":"top"}},[_c('h1',[_vm._v("Reporte Anual ")])]),_c('tabla_usuarios',{attrs:{"filas":_vm.filas,"columnas":_vm.columnas,"loading":_vm.loading,"anual":true,"show_expand":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }